import { type BaseQueryApi, fetchBaseQuery } from "@reduxjs/toolkit/query";
import { getHeaders } from "../../api/api.common";
import { getGlobalConfigAsync } from "../globalConfig";
import { type Config } from "../slice/config/types";

export async function appendHeaders(baseHeaders: Headers) {
	const headers = await getHeaders();
	if (headers) {
		for (const [headerName, headerValue] of Object.entries(headers)) {
			baseHeaders.set(headerName, headerValue);
		}
	}
	return baseHeaders;
}

export function createBaseQuery(baseUrlName: keyof Config["API_BASE_URLS"]) {
	return async (args: any, api: BaseQueryApi, extraOptions: Record<string, never>) => {
		const config = await getGlobalConfigAsync();
		return fetchBaseQuery({
			baseUrl: config.API_BASE_URLS[baseUrlName],
			prepareHeaders: appendHeaders,
		})(args, api, extraOptions);
	};
}
